import styled from 'styled-components'
import { color } from 'styles/colors'
import Checkbox from 'components/Checkbox'

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
`

export const NonZoneSection = styled.div.withConfig({
  shouldForwardProp: (prop) => !['flexWidth'].includes(prop)
})<{ flexWidth?: number }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  ${({ flexWidth = 180 }) => `flex: 0 0 ${flexWidth}px;`}
`

export const ZoneSection = styled.div.withConfig({
  shouldForwardProp: (prop) => !['columns'].includes(prop)
})<{ columns?: number }>`
display: grid;
${({ columns }) => `grid-template-columns: 1.5fr repeat(${columns}, 1fr);`}
align-items: center;
`

export const ListGroup = styled.div<{ direction?: string, gap?: number }>`
  display: flex;
  background-color: ${color('chartBackground')};
  padding: 10px;
  ${({ gap = 0 }) => `gap: ${gap}rem;`}
  ${({ direction = 'row' }) => `flex-direction: ${direction};`}
  border-radius: 0.625rem;
  flex-wrap: wrap;
  color: ${color('primaryText')};
`

export const Typography = styled.div.withConfig({
  shouldForwardProp: (prop) => !['size', 'fontWeight', 'alignCenter', 'marginBottom'].includes(prop)
})<{ size?: number, fontWeight?: number, alignCenter?: boolean, marginBottom?: number}>` 
  overflow:hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  ${({ size = 14 }) => `font-size: ${size}px;`}
  ${({ fontWeight = 600 }) => `font-weight: ${fontWeight};`}
  ${({ alignCenter = false }) => alignCenter && 'text-align: center;'}
  ${({ marginBottom = 0 }) => marginBottom && `margin-bottom: ${marginBottom}px;`}
`

export const CheckboxGroup = styled.div.withConfig({
  shouldForwardProp: (prop) => !['gap'].includes(prop)
})<{ gap?: number }>` 
  display: flex;
  flex-wrap: wrap;
  ${({ gap = 0 }) => `gap: ${gap}rem;`}
`

export const FilterCheckbox = styled(Checkbox).withConfig({
  shouldForwardProp: (prop) => !['autoWidth', 'disabled', 'alignCenter'].includes(prop)
})<{ autoWidth?: boolean, disabled?: boolean, alignCenter?: boolean }>`
  font-size: 12px;
  ${({ autoWidth = false }) => !autoWidth && 'width: 170px;'}
  ${({ alignCenter }) => alignCenter && 'justify-content: center;'}
  label{
    ${({ disabled = false }) => disabled && `color: ${color('secondaryText')};`}
  }
  input{
    margin-top: 1px;
    ${({ disabled = false }) => disabled && 'opacity: 0.5;'}
  }
  input:checked {
    accent-color: ${color('newLabelBackground')};;

  }
`
